<script>
  /**
   * A list of attribute-value pairs (`BaseAttributeValueListItem` components).
   */
  export default {
    props: {
      /** The size of the gap between list items. */
      gapSize: {
        type: String,
        default: 'sm',
        validator: (value) => ['none', 'sm', 'md', 'lg'].includes(value),
      },
    },
  }
</script>

<template>
  <!-- for purgecss: list--gap-none list--gap-sm list--gap-md list--gap-lg -->
  <dl :class="`list list--gap-${gapSize} leading-snug`">
    <!-- @slot The list items. Should contain one or multiple `BaseAttributeValueListItem` components. -->
    <slot />
  </dl>
</template>

<style lang="postcss" scoped>
  .list {
    &--gap-sm > * + * {
      margin-top: 0.25em;
    }

    &--gap-md > * + * {
      margin-top: 0.5em;
    }

    &--gap-lg > * + * {
      margin-top: 1em;
    }
  }
</style>
